import { render, staticRenderFns } from "./DsioList.vue?vue&type=template&id=2c490d74&"
import script from "./DsioList.vue?vue&type=script&lang=js&"
export * from "./DsioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c490d74')) {
      api.createRecord('2c490d74', component.options)
    } else {
      api.reload('2c490d74', component.options)
    }
    module.hot.accept("./DsioList.vue?vue&type=template&id=2c490d74&", function () {
      api.rerender('2c490d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioList.vue"
export default component.exports